import { render } from "./CompetenciesSection.vue?vue&type=template&id=53507700"
import script from "./CompetenciesSection.vue?vue&type=script&lang=js"
export * from "./CompetenciesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__